import { enumParser } from '#validation/common/parsers';
import { FilespaceVersion } from '../constants';
export const filespaceVersionParser = enumParser(FilespaceVersion);
